import React from 'react'
import withIcon from '@/components/withIcon'

function IconHeadBrain({ className }) {
  return (
    <svg
      className={className}
      width="29"
      height="29"
      viewBox="0 0 29 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.99373 27.5853V21.6502C5.99373 20.5506 5.10529 19.4681 4.4798 18.5599C3.26023 16.7891 2.54906 14.647 2.54906 12.3364C2.54906 6.27282 7.51872 1.35742 13.5823 1.35742C15.256 1.35742 17.078 1.54619 18.5003 2.21453C21.1277 3.44909 24.4927 6.21436 24.4927 10.1111C24.5356 10.5567 24.5498 11.5679 24.5413 12.002C24.5184 13.0588 24.7612 12.9613 25.1725 13.9353C25.5952 14.9349 26.1036 16.1431 26.4377 16.9314C26.6234 17.3741 26.3778 17.8796 25.9151 18.0081L24.4099 18.428C24.1014 18.5137 23.8729 18.7764 23.8329 19.0935L23.1817 22.5995C23.0716 23.6422 22.4306 24.2704 21.5081 24.2704L17.9289 24.2136V27.642"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M17.5123 8.35522C17.5295 8.20956 17.5409 8.06104 17.5409 7.91252C17.5409 5.96464 16.5004 4.50054 14.5005 4.21473C11.874 3.83937 11.0721 5.64324 10.7864 6.50035"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M17.3807 13.4499C19.0686 13.4499 21.011 12.6532 21.011 10.3909C21.011 8.70297 19.6429 7.33203 17.9521 7.33203C17.8121 7.33203 17.675 7.3406 17.5436 7.36059"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M11.9237 7.44031C10.7633 6.77037 9.11192 6.54713 8.21406 8.10227C7.54411 9.26264 7.94047 10.7481 9.10281 11.4191C9.19901 11.4747 9.29666 11.5232 9.39491 11.5616"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M7.36168 10.3164C6.51912 10.7277 5.93932 11.5931 5.93932 12.5956C5.93932 13.9951 6.81273 15.3561 8.21509 15.3561"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M14.9959 11.498C16.0841 11.498 16.9667 12.3806 16.9667 13.4688C16.9667 14.557 16.0841 15.4395 14.9959 15.4395H13.705C12.5711 15.4395 11.6514 16.3592 11.6514 17.4931V19.1896"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default withIcon(IconHeadBrain)
